import { render, staticRenderFns } from "./FormInputEventTargetType.vue?vue&type=template&id=20c18252&scoped=true&lang=pug"
import script from "./FormInputEventTargetType.vue?vue&type=script&lang=ts"
export * from "./FormInputEventTargetType.vue?vue&type=script&lang=ts"
import style0 from "./FormInputEventTargetType.vue?vue&type=style&index=0&id=20c18252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c18252",
  null
  
)

export default component.exports